import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-sujet-list',
  templateUrl: './note-sujet-list.component.html',
  styleUrls: ['./note-sujet-list.component.scss']
})
export class NoteSujetListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
